import { useEffect, useState } from "react";
import './AgriSimHero.css';

const API = process.env.REACT_APP_API_URL || "";

/* ─── Crop stage data — swap src paths to your real screenshots ─── */
const CROP_STAGES = [
    { label: 'Seeding', tag: '01', key: 'agrisimpage-hero-1' },
    { label: 'Pre-Harvest', tag: '02', key: 'agrisimpage-hero-2' },
    { label: 'Harvest', tag: '03', key: 'agrisimpage-hero-3' },
    { label: 'Field View', tag: '04', key: 'agrisimpage-hero-4' },
];

const NAV_LINKS = [
    { label: 'About', href: '#about' },
    { label: 'Vision', href: '#vision' },
    { label: 'Technology', href: '#technology' },
    { label: 'Capabilities', href: '#capabilities' },
    { label: 'Contact', href: '#request-demo' },
];

export default function Hero() {
    const [images, setImages] = useState({});

    useEffect(() => {
        fetch(`${API}/api/media/agrisimpage`)
            .then((res) => (res.ok ? res.json() : {}))
            .then((data) => setImages(data))
            .catch(() => { });
    }, []);
    /* Inject Google model-viewer once */
    useEffect(() => {
        if (document.querySelector('#mv-script')) return;
        const s = document.createElement('script');
        s.id = 'mv-script';
        s.type = 'module';
        s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js';
        document.head.appendChild(s);
    }, []);

    return (
        <section className="sf-hero">

            {/* ── Background ─────────────────────────────────────── */}
            <div className="sf-hero__bg" aria-hidden="true">
                {/* Replace src with your UE5 environment screenshot */}
                <img src="/images/environment-bg.jpg" alt="" draggable="false" />
                <div className="sf-hero__bg-vignette" />
                <div className="sf-hero__bg-overlay" />
            </div>

            {/* ── Grain texture overlay ──────────────────────────── */}
            <div className="sf-hero__grain" aria-hidden="true" />

            {/* ── Navbar ─────────────────────────────────────────── */}
            <nav className="sf-nav">
                <div className="sf-nav__logo">
                    <span className="sf-nav__company">Aviatricks Aero Labs</span>
                    <span className="sf-nav__divider" aria-hidden="true" />
                    <span className="sf-nav__product">Agri Drone Simulator</span>
                </div>

                <ul className="sf-nav__links" role="list">
                    {NAV_LINKS.map(({ label, href }) => (
                        <li key={href}>
                            <a href={href} className="sf-nav__link">{label}</a>
                        </li>
                    ))}
                    <li>
                        <a href="#request-demo" className="sf-nav__cta-pill">Request Demo</a>
                    </li>
                </ul>
            </nav>

            {/* ── Hero body ──────────────────────────────────────── */}
            <div className="sf-hero__body">

                {/* LEFT — 2×2 Crop grid */}
                <div className="sf-crop-grid" aria-label="Crop stages">
                    {CROP_STAGES.map(({ label, tag, key }) => (
                        <div key={tag} className="sf-crop-card">
                            <img
                                src={images[key] || "/images/fallback.jpg"}
                                alt={label}
                                className="sf-crop-card__img"
                            />
                            <div className="sf-crop-card__footer">
                                <span className="sf-crop-card__tag">{tag}</span>
                                <span className="sf-crop-card__label">{label}</span>
                            </div>
                            <div className="sf-crop-card__shine" aria-hidden="true" />
                        </div>
                    ))}
                </div>

                {/* CENTER — Title block */}
                <div className="sf-title-block">
                    <span className="sf-title-block__eyebrow">Agri Drone Simulation</span>

                    <h1 className="sf-title-block__heading">
                        <span className="sf-title-block__sky">Agri Drone</span>
                        <span className="sf-title-block__farm">Simulator</span>
                    </h1>

                    <p className="sf-title-block__tagline">
                        Train like it's real.<br />
                        <em>Before it is.</em>
                    </p>

                    <div className="sf-title-block__actions">
                        <a href="#request-demo" className="sf-btn sf-btn--primary">
                            Request a Demo
                            <span className="sf-btn__arrow" aria-hidden="true">→</span>
                        </a>
                        <a href="#about" className="sf-btn sf-btn--ghost">Learn More</a>
                    </div>

                    <p className="sf-title-block__built-by">
                        Built by real drone pilots &mdash; hundreds of flight hours
                    </p>
                </div>

                {/* RIGHT — 3D Drone model */}
                <div className="sf-model-wrap" aria-label="Interactive drone model">
                    {/* Replace src with your actual .glb path */}
                    <model-viewer
                        src="/models/phone.glb"
                        alt="Agri Drone 3D Model"
                        camera-controls
                        auto-rotate
                        auto-rotate-delay="1000"
                        rotation-per-second="20deg"
                        shadow-intensity="0.6"
                        exposure="1.1"
                        environment-image="neutral"
                        style={{
                            width: '100%',
                            height: '100%',
                            background: 'transparent',
                            '--progress-bar-color': '#A8E63D',
                        }}
                    />
                    <div className="sf-model__hint" aria-hidden="true">
                        <span>⟳</span> Drag to rotate
                    </div>
                    <div className="sf-model__glow" aria-hidden="true" />
                </div>

            </div>

            {/* ── Bottom scroll cue ──────────────────────────────── */}
            <div className="sf-hero__scroll-cue" aria-hidden="true">
                <span className="sf-hero__scroll-line" />
                <span className="sf-hero__scroll-text">Scroll</span>
            </div>

        </section>
    );
}